import Vue from "vue"
import Vuex from "vuex"
import services from './modules/services'
import accessibility from './modules/accessibility'
import faq from './modules/faq'

import lead from "./modules/form/lead.js"

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    services,
    accessibility,
    faq,
    lead
  },
  strict: debug
})